import FaultTypesItems from './FaultTypesItems.vue'
export default FaultTypesItems


// WEBPACK FOOTER //
// ./src/pages/FaultTypesItems/index.js